// ==========================================================================
// TSUKE MOZUKU LP - Shopify Theme JavaScript
// ==========================================================================

document.addEventListener('DOMContentLoaded', function() {
    initHeader();
    initMobileMenu();
    initScrollAnimations();
    initProductCarousels();
    initRecipeSlider();
    initMeistersSlider();
    initFAQAccordion();
    initFixedPurchaseButton();
    initProductModal();
});

// ==========================================================================
// ヘッダースクロール処理
// ==========================================================================

function initHeader() {
    const header = document.querySelector('.lp-header');
    const heroSection = document.querySelector('.lp-hero');

    function onScroll() {
        const scrollY = window.scrollY;
        const heroHeight = heroSection ? heroSection.offsetHeight : 0;

        // ヘッダーの変化
        if (scrollY > 100) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

        // Heroセクションのぼかしエフェクト
        if (heroSection && heroHeight > 0) {
            const scrollProgress = Math.min(scrollY / heroHeight, 1);

            let blurAmount = 0;
            let opacityAmount = 1;

            if (scrollProgress > 0.5) {
                const blurProgress = (scrollProgress - 0.5) / 0.5;
                blurAmount = blurProgress * 35;
                opacityAmount = 1 - (blurProgress * 0.4);
            }

            heroSection.style.filter = `blur(${blurAmount}px)`;
            heroSection.style.opacity = opacityAmount;
        }
    }

    window.addEventListener('scroll', onScroll);
    // JS読み込み前にスクロール済みの場合も正しい状態を反映
    onScroll();
}

// ==========================================================================
// モバイルメニュー
// ==========================================================================

function initMobileMenu() {
    const menuToggle = document.querySelector('.menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    const mobileNavLinks = document.querySelectorAll('.mobile-nav a');
    const header = document.querySelector('.lp-header');

    if (!menuToggle || !mobileMenu) return;

    menuToggle.addEventListener('click', () => {
        menuToggle.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        
        if (mobileMenu.classList.contains('active')) {
            header.classList.add('menu-open');
            document.body.style.overflow = 'hidden';
        } else {
            header.classList.remove('menu-open');
            document.body.style.overflow = '';
        }
    });

    mobileNavLinks.forEach(link => {
        link.addEventListener('click', () => {
            menuToggle.classList.remove('active');
            mobileMenu.classList.remove('active');
            header.classList.remove('menu-open');
            document.body.style.overflow = '';
        });
    });
}

// ==========================================================================
// スクロールアニメーション
// ==========================================================================

function initScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const fadeInObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add('visible');
                }, index * 150);
            }
        });
    }, observerOptions);

    document.querySelectorAll('.fade-in').forEach(element => {
        fadeInObserver.observe(element);
    });
}

// ==========================================================================
// 商品カルーセル
// ==========================================================================

function initProductCarousels() {
    document.querySelectorAll('.product-carousel').forEach(carouselElement => {
        new ProductCarousel(carouselElement);
    });
}

class ProductCarousel {
    constructor(carouselElement) {
        this.carousel = carouselElement;
        this.images = carouselElement.querySelectorAll('.carousel-image');
        this.dotsContainer = carouselElement.querySelector('.carousel-dots');
        this.prevBtn = carouselElement.querySelector('.prev');
        this.nextBtn = carouselElement.querySelector('.next');
        this.currentIndex = 0;
        this.autoPlayInterval = null;
        
        if (this.images.length > 0) {
            this.init();
        }
    }
    
    init() {
        this.generateDots();
        this.dots = this.dotsContainer.querySelectorAll('.dot');
        
        this.prevBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.prev();
        });
        
        this.nextBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.next();
        });
        
        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', (e) => {
                e.stopPropagation();
                this.goTo(index);
            });
        });
        
        this.startAutoPlay();
        
        this.carousel.addEventListener('mouseenter', () => this.stopAutoPlay());
        this.carousel.addEventListener('mouseleave', () => this.startAutoPlay());
    }
    
    generateDots() {
        this.dotsContainer.innerHTML = '';
        
        this.images.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.classList.add('dot');
            if (index === 0) {
                dot.classList.add('active');
            }
            this.dotsContainer.appendChild(dot);
        });
    }
    
    goTo(index) {
        this.images[this.currentIndex].classList.remove('active');
        this.dots[this.currentIndex].classList.remove('active');
        
        this.currentIndex = index;
        
        this.images[this.currentIndex].classList.add('active');
        this.dots[this.currentIndex].classList.add('active');
    }
    
    next() {
        const nextIndex = (this.currentIndex + 1) % this.images.length;
        this.goTo(nextIndex);
    }
    
    prev() {
        const prevIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this.goTo(prevIndex);
    }
    
    startAutoPlay() {
        this.autoPlayInterval = setInterval(() => {
            this.next();
        }, 4300);
    }
    
    stopAutoPlay() {
        if (this.autoPlayInterval) {
            clearInterval(this.autoPlayInterval);
        }
    }
}

// ==========================================================================
// レシピスライダー
// ==========================================================================

function initRecipeSlider() {
    const container = document.querySelector('.recipes-container');
    const items = document.querySelectorAll('.recipe-item');
    const prevBtn = document.querySelector('.lp-recipes .slider-btn.prev');
    const nextBtn = document.querySelector('.lp-recipes .slider-btn.next');
    const dots = document.querySelectorAll('.lp-recipes .slider-dots .dot');
    let currentIndex = 0;
    let initialized = false;

    if (!container || items.length === 0) return;

    function init() {
        if (initialized) return;
        initialized = true;
        
        prevBtn?.addEventListener('click', prev);
        nextBtn?.addEventListener('click', next);
        
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => goTo(index));
        });
        
        // スワイプ検出
        let startX = 0;
        let currentX = 0;
        
        container.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });
        
        container.addEventListener('touchmove', (e) => {
            currentX = e.touches[0].clientX;
        });
        
        container.addEventListener('touchend', () => {
            const diff = startX - currentX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    next();
                } else {
                    prev();
                }
            }
        });
    }
    
    function goTo(index) {
        currentIndex = index;
        const scrollLeft = items[index].offsetLeft;
        container.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
        });
        updateDots();
    }
    
    function next() {
        currentIndex = Math.min(currentIndex + 1, items.length - 1);
        goTo(currentIndex);
    }
    
    function prev() {
        currentIndex = Math.max(currentIndex - 1, 0);
        goTo(currentIndex);
    }
    
    function updateDots() {
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
        });
    }

    if (window.innerWidth <= 768) {
        init();
    }
    
    window.addEventListener('resize', () => {
        if (window.innerWidth <= 768 && !initialized) {
            init();
        }
    });
}

// ==========================================================================
// マイスタースライダー
// ==========================================================================

function initMeistersSlider() {
    const meistersSection = document.querySelector('.lp-meisters');
    if (!meistersSection) return;
    
    const items = meistersSection.querySelectorAll('.meister-item');
    const dots = meistersSection.querySelectorAll('.slider-dots .dot');
    const prevBtn = meistersSection.querySelector('.slider-btn.prev');
    const nextBtn = meistersSection.querySelector('.slider-btn.next');
    
    let currentIndex = 0;
    
    function showSlide(index) {
        items.forEach(item => item.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));
        
        if (items[index]) {
            items[index].classList.add('active');
        }
        if (dots[index]) {
            dots[index].classList.add('active');
        }
        
        currentIndex = index;
    }
    
    function nextSlide() {
        const nextIndex = (currentIndex + 1) % items.length;
        showSlide(nextIndex);
    }
    
    function prevSlide() {
        const prevIndex = (currentIndex - 1 + items.length) % items.length;
        showSlide(prevIndex);
    }
    
    nextBtn?.addEventListener('click', nextSlide);
    prevBtn?.addEventListener('click', prevSlide);
    
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => showSlide(index));
    });
    
    showSlide(0);
}

// ==========================================================================
// FAQ アコーディオン
// ==========================================================================

function initFAQAccordion() {
    const faqItems = document.querySelectorAll('.faq-item');
    const btnMoreFaq = document.querySelector('.btn-more-faq');
    const faqAdditional = document.querySelector('.faq-additional');
    const faqMoreContainer = document.querySelector('.faq-more-container');

    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        
        question?.addEventListener('click', () => {
            const isActive = item.classList.contains('active');
            
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('active');
                }
            });
            
            item.classList.toggle('active', !isActive);
        });
    });

    if (btnMoreFaq && faqAdditional) {
        btnMoreFaq.addEventListener('click', () => {
            faqAdditional.classList.add('visible');
            
            const additionalItems = faqAdditional.querySelectorAll('.faq-item');
            additionalItems.forEach((item, index) => {
                setTimeout(() => {
                    item.style.opacity = '1';
                }, index * 100);
            });
            
            setTimeout(() => {
                faqMoreContainer.classList.add('hidden');
            }, 300);
            
            setTimeout(() => {
                const firstAdditionalItem = additionalItems[0];
                if (firstAdditionalItem) {
                    const header = document.querySelector('.lp-header');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const targetPosition = firstAdditionalItem.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 400);
        });
    }
}

// ==========================================================================
// 固定購入ボタン
// ==========================================================================

function initFixedPurchaseButton() {
    const fixedPurchaseBtn = document.getElementById('fixedPurchaseBtn');
    const heroPurchaseBtn = document.getElementById('heroPurchaseBtn');
    const productsSection = document.getElementById('products');
    const faqSection = document.getElementById('faq');

    if (!fixedPurchaseBtn) return;

    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        
        if (productsSection && faqSection) {
            const productsSectionTop = productsSection.getBoundingClientRect().top + scrollY;
            const faqSectionTop = faqSection.getBoundingClientRect().top + scrollY;
            
            if (scrollY >= productsSectionTop - 100 && scrollY < faqSectionTop - 100) {
                fixedPurchaseBtn.classList.add('visible');
            } else {
                fixedPurchaseBtn.classList.remove('visible');
            }
        }
    });

    fixedPurchaseBtn.addEventListener('click', () => {
        window.currentProductIndex = 0;
        openModal();
    });

    heroPurchaseBtn?.addEventListener('click', () => {
        window.currentProductIndex = 0;
        openModal();
    });
}

// ==========================================================================
// 商品詳細モーダル
// ==========================================================================

let productsData = [];
let currentProductIndex = 0;
let currentImageIndex = 0;

function initProductModal() {
    const productModal = document.getElementById('productModal');
    if (!productModal) return;

    const modalOverlay = productModal.querySelector('.modal-overlay');
    const modalClose = productModal.querySelector('.modal-close');
    const modalPrevBtn = productModal.querySelector('.modal-prev');
    const modalNextBtn = productModal.querySelector('.modal-next');
    const quantityMinusBtn = productModal.querySelector('.quantity-btn.minus');
    const quantityPlusBtn = productModal.querySelector('.quantity-btn.plus');
    const quantityInput = productModal.querySelector('.quantity-input');
    const btnModalAddCart = productModal.querySelector('.btn-modal-add-cart');

    // 商品データを取得（data属性から）
    loadProductsData();

    // 商品カードのクリックイベント
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach((card, index) => {
        card.addEventListener('click', (e) => {
            if (e.target.classList.contains('btn-add-cart')) return;
            if (e.target.closest('.carousel-btn') || e.target.classList.contains('dot')) return;
            
            currentProductIndex = index;
            openModal();
        });
    });

    // カートに追加ボタン（在庫なしの場合はスキップ）
    productCards.forEach((card, index) => {
        const button = card.querySelector('.btn-add-cart:not(.btn-coming-soon)');
        if (!button) return;
        
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            const product = productsData[index];
            if (product && product.variantId && product.available) {
                addToCart(product.variantId, 1);
            }
        });
    });

    modalClose?.addEventListener('click', closeModal);
    modalOverlay?.addEventListener('click', closeModal);
    
    modalPrevBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        showPrevProduct();
    });
    
    modalNextBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        showNextProduct();
    });

    quantityMinusBtn?.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
        }
    });

    quantityPlusBtn?.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue < 99) {
            quantityInput.value = currentValue + 1;
        }
    });

    btnModalAddCart?.addEventListener('click', () => {
        const product = productsData[currentProductIndex];
        const quantity = parseInt(quantityInput.value);
        
        if (product && product.variantId && product.available) {
            addToCart(product.variantId, quantity);
        }
    });

    // キーボードショートカット
    document.addEventListener('keydown', (e) => {
        if (!productModal.classList.contains('active')) return;
        
        if (e.key === 'Escape') {
            closeModal();
        } else if (e.key === 'ArrowLeft') {
            showPrevProduct();
        } else if (e.key === 'ArrowRight') {
            showNextProduct();
        }
    });
}

function loadProductsData() {
    const productCards = document.querySelectorAll('.product-card');
    productsData = [];
    
    productCards.forEach((card) => {
        const data = {
            id: card.dataset.productId || '',
            variantId: card.dataset.variantId || '',
            name: card.dataset.productName || 'TSUKE MOZUKU',
            subtitle: card.dataset.productSubtitle || '',
            description: card.dataset.productDescription || '',
            price: card.dataset.productPrice || '',
            available: card.dataset.productAvailable !== 'false',
            images: (card.dataset.productImages || '').split(',').filter(img => img),
            details: (card.dataset.productDetails || '').split('|').filter(detail => detail)
        };
        productsData.push(data);
    });
}

function openModal() {
    const productModal = document.getElementById('productModal');
    if (!productModal || productsData.length === 0) return;
    
    currentImageIndex = 0;
    updateModalContent();
    productModal.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeModal() {
    const productModal = document.getElementById('productModal');
    if (!productModal) return;
    
    productModal.classList.remove('active');
    setTimeout(() => {
        document.body.style.overflow = '';
    }, 500);
}

function updateModalContent() {
    const product = productsData[currentProductIndex];
    if (!product) return;
    
    const modalProductTitle = document.querySelector('.modal-product-title');
    const modalProductDescription = document.querySelector('.modal-product-description');
    const modalProductPrice = document.querySelector('.modal-product-price');
    const modalDetailsList = document.querySelector('.modal-details-list');
    const modalThumbnails = document.querySelector('.modal-thumbnails');
    const quantityInput = document.querySelector('.quantity-input');

    if (modalProductTitle) {
        modalProductTitle.innerHTML = `<span style="font-size: 0.75em;">${product.name.replace(/,/g, '<br>')}</span><br><span style="font-size: 0.85em; font-weight: 400;">${product.subtitle}</span>`;
    }
    
    if (modalProductDescription) {
        modalProductDescription.innerHTML = product.description.replace(/\n/g, '<br>');
    }
    
    if (modalProductPrice) {
        modalProductPrice.innerHTML = `${product.price}<span class="tax">(税込・送料込)</span>`;
    }
    
    // モーダルのカート追加セクション（在庫なしの場合は非表示）
    const modalActions = document.querySelector('.modal-actions');
    if (modalActions) {
        modalActions.style.display = product.available ? '' : 'none';
    }
    
    if (modalDetailsList) {
        modalDetailsList.innerHTML = product.details.map(detail => `<li>${detail}</li>`).join('');
    }
    
    updateModalImage();
    
    if (modalThumbnails && product.images.length > 0) {
        modalThumbnails.innerHTML = product.images.map((img, idx) => `
            <div class="modal-thumbnail ${idx === 0 ? 'active' : ''}" data-index="${idx}">
                <img src="${img}" alt="${product.name}">
            </div>
        `).join('');
        
        const thumbnails = modalThumbnails.querySelectorAll('.modal-thumbnail');
        thumbnails.forEach(thumb => {
            thumb.addEventListener('click', () => {
                currentImageIndex = parseInt(thumb.dataset.index);
                updateModalImage();
            });
        });
    }
    
    if (quantityInput) {
        quantityInput.value = 1;
    }
}

function updateModalImage() {
    const product = productsData[currentProductIndex];
    if (!product || product.images.length === 0) return;
    
    const modalMainImage = document.getElementById('modalMainImage');
    const modalThumbnails = document.querySelector('.modal-thumbnails');
    
    if (modalMainImage) {
        modalMainImage.src = product.images[currentImageIndex];
        modalMainImage.alt = product.name;
    }
    
    if (modalThumbnails) {
        const thumbnails = modalThumbnails.querySelectorAll('.modal-thumbnail');
        thumbnails.forEach((thumb, idx) => {
            thumb.classList.toggle('active', idx === currentImageIndex);
        });
    }
}

function showPrevProduct() {
    currentProductIndex = currentProductIndex === 0 ? productsData.length - 1 : currentProductIndex - 1;
    currentImageIndex = 0;
    updateModalContent();
}

function showNextProduct() {
    currentProductIndex = currentProductIndex === productsData.length - 1 ? 0 : currentProductIndex + 1;
    currentImageIndex = 0;
    updateModalContent();
}

// ==========================================================================
// Shopify カート追加機能
// ==========================================================================

function addToCart(variantId, quantity) {
    if (!variantId) {
        console.error('No variant ID provided');
        return;
    }
    
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Added to cart:', data);
        // カートページへリダイレクト
        window.location.href = '/cart';
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        alert('カートへの追加に失敗しました。もう一度お試しください。');
    });
}

// ==========================================================================
// スムーススクロール
// ==========================================================================

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        
        if (href === '#' || href === '') {
            e.preventDefault();
            return;
        }
        
        const target = document.querySelector(href);
        
        if (target) {
            e.preventDefault();
            const header = document.querySelector('.lp-header');
            const headerHeight = header ? header.offsetHeight : 0;
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
});

// ==========================================================================
// デバッグ用
// ==========================================================================

console.log('%c🌊 TSUKE MOZUKU LP Loaded Successfully! 🌊', 'color: #2d5f4c; font-size: 16px; font-weight: bold;');
